import { of } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { IClientApiDependencySegment, catchApiError } from '@cbridge-packages/api';
import { createApiErrorNotification } from '@cbridge-packages/notification';
import { SymbolSyntheticAction } from '../symbolSynthetic.action';

type IDependencies = IClientApiDependencySegment;

export const removeSymbolSyntheticEpic: IEpic<{}, IDependencies> = (action$, _, dependencies) => action$.pipe(
  isTypeOfAndGetPayload(SymbolSyntheticAction.remove.started),
  mergeMap((params) => {
    const { symbolId } = params;
    return dependencies.api.deleteSyntheticSymbol({ symbolId }).pipe(
      mergeMap(() =>
        of(SymbolSyntheticAction.remove.done({ params })),
      ),
      catchApiError((error) =>
        of(
          SymbolSyntheticAction.remove.failed({ params, error: null }),
          createApiErrorNotification(error),
        ),
      ),
    );
  }),
);
